var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0c.279 0 .539.142.693.379l1.42 2.171H17.5c1.38 0 2.5 1.142 2.5 2.55v9.35c0 1.408-1.12 2.55-2.5 2.55h-15C1.12 17 0 15.858 0 14.45V5.1c0-1.408 1.12-2.55 2.5-2.55h2.887L6.807.379C6.96.142 7.22 0 7.5 0h5zM10 5.383c-2.148 0-3.889 1.776-3.889 3.967 0 2.19 1.741 3.967 3.889 3.967 2.148 0 3.889-1.776 3.889-3.967 0-2.19-1.741-3.967-3.889-3.967z",
    transform: "translate(-472 -498) translate(40 498) translate(432) translate(2 4)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraFilled);
export default __webpack_public_path__ + "static/media/camera_filled.33fb3214.svg";
export { ForwardRef as ReactComponent };